var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "filter_icon_a",
  d: "M8 15c0 .351.06.688.171 1H0v-2h8.17c-.11.313-.17.65-.17 1zm10-1v2h-4.171c.11-.312.171-.649.171-1 0-.35-.06-.687-.17-1H18zM2 8c0 .351.06.688.171 1H0V7h2.17c-.11.313-.17.65-.17 1zm16-1v2H7.829c.11-.312.171-.649.171-1 0-.35-.06-.687-.17-1H18zM9 1c0 .351.06.688.171 1H0V0h9.171C9.061.311 9 .65 9 1zm9-1v2h-3.171c.11-.312.171-.649.171-1 0-.35-.06-.688-.171-1H18z"
}), /*#__PURE__*/React.createElement("path", {
  id: "filter_icon_c",
  d: "M8 14c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zM2 7c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm7-7c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "filter_icon_b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#filter_icon_a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#filter_icon_b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L24 0 24 24 0 24z",
  transform: "translate(-3 -4)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6 3)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#filter_icon_c"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#prefix__d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L24 0 24 24 0 24z",
  transform: "translate(-6 -3)"
}))));
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.d3c8e349fefc48616fca6b6a63a2775f.svg";
export { ForwardRef as ReactComponent };